module.exports = __webpack_public_path__ + "img/code.9acebc70.png";